import { render } from "./TheStickyMenu.vue?vue&type=template&id=127a8675&scoped=true"
import script from "./TheStickyMenu.vue?vue&type=script&lang=js"
export * from "./TheStickyMenu.vue?vue&type=script&lang=js"

import "./TheStickyMenu.vue?vue&type=style&index=0&id=127a8675&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-127a8675"

export default script